export default __webpack_public_path__ + "static/media/banner-close.65e48510.svg";